import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=705f06cf&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=705f06cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f06cf",
  null
  
)

export default component.exports